import { schema } from "normalizr";
import { CombineKeys } from "utils/functions";

export const offerPartnerContactModeSchema = new schema.Entity(
  "offerPartnerContactModes",
  {},
  { idAttribute: offerPartner => offerPartner.partnerContactModeId }
);


export const loadOfferPartnerSchema = new schema.Entity(
  "offerPartners",
  {},
  { idAttribute: offerPartner => offerPartner.partnerId }
);

export const offerPartnerAddressesSchema = new schema.Entity("offerPartnerAddresses", {}, { idAttribute: addresses => addresses.partnerId });
export const loadOfferPartnerVerificationsSchema = new schema.Entity(
  "offerPartnerVerifications",
  {},
  { idAttribute: verifications => verifications.partnerId }
);
export const loadOfferPartnerEligibilitiesSchema = new schema.Entity(
  "offerPartnerEligibilities",
  {},
  { idAttribute: eligibilities => eligibilities.partnerId }
);
export const loadOfferPartnerKnockoutCriteriaSchema = new schema.Entity(
  "offerPartnerKnockoutCriteria",
  {},
  { idAttribute: knockoutCriteria => knockoutCriteria.partnerId }
);
export const loadOfferPartnerConsentsSchema = new schema.Entity(
  "offerPartnerConsents",
  {},
  { idAttribute: consents => consents.partnerId }
);
export const loadOfferPartnerBankAccountsSchema = new schema.Entity(
  "offerPartnerBankAccounts",
  {},
  { idAttribute: bankAccount => bankAccount.id }
);

export const loadOfferPartnerQuestionsSchema = new schema.Entity(
  "offerPartnerQuestions",
  {},
  { idAttribute: item => `${item.documentId}-${item.siteId}-${item.partnerId}` }
);

export const loadOfferPartnerQuestionActionsSchema = new schema.Entity(
  "offerPartnerQuestionActions",
  {},
  { idAttribute: item => `${item.documentId}-${item.siteId}-${item.partnerId}` }
);

export const loadOfferPartnerMonthlyObligationsSchema = new schema.Entity(
  "offerPartnerMonthlyObligations",
  {},
  {
    idAttribute: partnerMonthlyObligations => partnerMonthlyObligations.partnerId
  }
);
export const loadOfferPartnerActivitiesSchema = new schema.Entity(
  "offerPartnerActivities",
  {},
  { idAttribute: activityFields => activityFields.partnerId }
);
export const loadOfferPartnerIncomeTypesSchema = new schema.Entity(
  "offerPartnerIncomeTypes",
  {},
  { idAttribute: partnerIncomeTypes => partnerIncomeTypes.partnerId }
);
export const loadOfferPartnerIncomeDataSchema = new schema.Entity(
  "offerPartnerIncomeData",
  {},
  {
    idAttribute: partnerIncomeData => CombineKeys(partnerIncomeData.partnerId, partnerIncomeData.incomeTypeId)
  }
);
export const scoringSchema = new schema.Entity("scoring", {}, { idAttribute: scoring => scoring.id });

export const scoringHistorySchema = new schema.Entity(
  "scoringHistory",
  {},
  { idAttribute: scoring => scoring.sessionID }
);

export const partnerSchema = new schema.Entity(
  "partners",
  {},
  {
    idAttribute: partner => {
      if (partner.clientId) return partner.clientId;
      return partner.partnerId;
    },
    processStrategy: entity => {
      const partner = {
        partnerId: entity.clientId,
        partnerName: entity.clientName,
        ...entity
      };
      delete partner.clientId;
      delete partner.clientName;
      return partner;
    }
  }
);

const decisionSummarySchema = new schema.Entity("summary", {});
const decisionApprovalLevelsSchema = new schema.Entity(
  "approvalLevels",
  {},
  { idAttribute: approvalLevel => approvalLevel.approvalLevelId }
);

const decisionApprovalsHistorySchema = new schema.Entity(
  "approvalsHistory",
  {},
  { idAttribute: approvalHistory => approvalHistory.documentApprovalsHistoryId }
);
const decisionContractGenPermissionsSchema = new schema.Entity("contractGenPermissions", {});
export const folderOffersSchema = new schema.Entity(
  "folderOffers",
  {},
  { idAttribute: item => `${item.offerId}-${item.offerSiteId}` }
);
export const decisionSchema = new schema.Entity(
  "decision",
  {
    summary: { decisionSummarySchema },
    approvalLevels: [decisionApprovalLevelsSchema],
    approvalsHistory: [decisionApprovalsHistorySchema],
    contractGenPermissions: { decisionContractGenPermissionsSchema },
    folderOffers: [folderOffersSchema]
  },
  { idAttribute: decision => decision.id }
);

const charismaExposureSchema = new schema.Entity("charismaExposure", {}, { idAttribute: item => item.id });
const webExposureSchema = new schema.Entity("webExposure", {}, { idAttribute: item => item.id });
const exposureDynamicFieldsSchema = new schema.Entity("exposureDynamicFields", {}, { idAttribute: item => item.id });
const exposureCurrency = new schema.Entity("exposureCurrencies", {}, { idAttribute: item => item.currencyId });

export const documentVerificationsSchema = new schema.Entity(
  "verifications",
  {},
  { idAttribute: item => item.verificationId }
);

export const exposureSchema = new schema.Entity(
  "exposure",
  {
    charismaExposure: [charismaExposureSchema],
    webExposure: [webExposureSchema],
    exposureDynamicFields: [exposureDynamicFieldsSchema],
    exposureCurrencies: [exposureCurrency]
  },
  { idAttribute: exposure => exposure.id }
);

export const checkListDetailSchema = new schema.Entity(
  "checklistDetails",
  {},
  {
    idAttribute: detail => `${detail.documentId}_${detail.siteId}_${detail.id}`
  }
);

export const checkListSchema = new schema.Entity(
  "checklist",
  {
    checklistDetails: [checkListDetailSchema]
  },
  {
    idAttribute: type => type.id
  }
);

export const commissionsDetailSchema = new schema.Entity(
  "commissionsDetails",
  {},
  { idAttribute: detail => detail.documentCommissionId }
);

export const commissionsSchema = new schema.Entity(
  "commissions",
  {
    commissionsDetails: [commissionsDetailSchema]
  },
  {
    idAttribute: type => type.id
  }
);

export const calculationMethodsSchema = new schema.Entity(
  "calculationMethods",
  {},
  {
    idAttribute: type => type.calculationMethodId
  }
);

export const leasingExpensesDetailsSchema = new schema.Entity(
  "offerLeasingExpensesDetails",
  {},
  { idAttribute: detail => `${detail.documentId}_${detail.siteId}_${detail.leasingExpenseId}` }
);

export const leasingExpensesSchema = new schema.Entity(
  "offerLeasingExpenses",
  {
    offerLeasingExpensesDetails: [leasingExpensesDetailsSchema]
  },
  {
    idAttribute: type => type.id
  }
);

export const availableUploadDocumentsSchema = new schema.Entity(
  "availableUploadDocuments",
  {},
  { idAttribute: availableUploadDocument => availableUploadDocument.uniqueId }
);
export const exportDocumentsSchema = new schema.Entity(
  "exportDocuments",
  {},
  { idAttribute: exportDocument => exportDocument.documentPrintId }
);
export const uploadDocumentsSchema = new schema.Entity(
  "uploadDocuments",
  {},
  { idAttribute: uploadDocument => uploadDocument.uniqueId }
);
export const documentPartnersSchema = new schema.Entity(
  "documentPartners",
  {},
  { idAttribute: documentPartner => documentPartner.partnerId }
);

export const documentAssetsSchema = new schema.Entity(
  "documentAssets",
  {},
  { idAttribute: documentAsset => documentAsset.documentDetailId }
);

export const documentsSchema = new schema.Entity(
  "documents",
  {
    availableUploadDocuments: [availableUploadDocumentsSchema],
    exportDocuments: [exportDocumentsSchema],
    uploadDocuments: [uploadDocumentsSchema],
    documentAssets: [documentAssetsSchema],
    documentPartners: [documentPartnersSchema]
  },
  { idAttribute: documents => documents.id }
);

export const positionsSchema = new schema.Entity("positions", {}, { idAttribute: type => type.positionId });
